// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3uWaF","approved":"Status_approved__pJUrc","rejected":"Status_rejected__MMxgE","expired":"Status_expired__3H2De","label":"Status_label__3UthD"};